import React, { useEffect, useRef, useState } from 'react';
import classes from './GeneralInfo.module.css';
import cloneDeep from 'lodash.clonedeep';
import { Constants } from '../../../../Constants';
import { useAppContext } from '../../../../Context/AppContext';
import Rating from '../../../Shared/Rating';
import Input from '../../../Shared/Forms/Input';
import InputWithLabel from '../../../Shared/Forms/InputWithLabel';
import { replaceValueForKey, testForSQLInjection } from '../../../../Utility';
import Dropdown from '../../../Shared/Forms/Dropdown';
import AutoComplete from '../../../Shared/AutoComplete';
import { Urls } from '../../../../Urls';
import Axios from '../../../../Axios/Axios'
import { toast } from 'react-toastify';
import { useCheckDuplicateTransporterName } from '../../../../hooks/useCheckDuplicateTransporterName';

const GeneralInfo = () => {
  const { isEditable, transporterInfo, navigatigAway } = useAppContext();

  return (
    <div className={classes.container}>
      {isEditable ? (
        <EditMode
          transporterInfo={transporterInfo}
          navigatigAway={navigatigAway}
        />
      ) : (
        <ReadOnly {...transporterInfo} />
      )}
    </div>
  );
};

const ReadOnly = ({
  transporter_name,
  company_type,
  headquarter,
  established,
  zone = [],
  overall_rating,
  number_of_ratings,
  experience_year,
  company_act
}) => (
  <>
    <label>{transporter_name || '-'} </label>
    <div>{company_type || '-'}</div>
    {overall_rating && !isNaN(parseFloat(overall_rating)) ? (
      <Rating
        initialRating={parseFloat(overall_rating).toFixed(2)}
        numberOfRatings={number_of_ratings}
        fractions={2}
        readonly
      />
    ) : null}
    <div>
      <label>Registered office address: </label>
      <span className={classes['spanforaddress']}> {headquarter || '-'}</span>
    </div>
    <div>
      <label>Established: </label>
      <span className={classes['spanforaddress']}> {established || '-'}</span>
    </div>
    <div>
      <label>Area of Operation: </label>
      {<div>{zone.join(', ') || '-'}</div>}
    </div>
    <div>
      <label>Industry Experience: </label>
      {<div>{experience_year || '-'}</div>}
    </div>
    {/*  <div>
      <label>Incorporated under Companies Act: </label>
      {<div> {company_act || '-'}</div>}
    </div> */}
  </>
);

const EditMode = ({ transporterInfo, navigatigAway }) => {
  const [ischeck, setischeck] = useState(false)
  const { checkDuplicate } = useCheckDuplicateTransporterName();
  const debounceRef = useRef(null);

  const transporterCheck = (value) => {
    if (!testForSQLInjection(value)) {
      toast.info("Enter valid Transporter Name");
      return;
    }

    

    // clear previous call
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(async () => {
      try {
        const isDuplicate = await checkDuplicate(
          value,
          transporterInfo.transporter_id
        );

        setischeck(isDuplicate);
        replaceValueForKey(transporterInfo, "transporter_name", value);
      } catch (err) {
        console.log(err);
      }
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  return (
    <>
      <Input
        placeholder="Transporter name"
        defaultValue={transporterInfo.transporter_name}
        onChange={value =>
          transporterCheck(value)
        }
        isInvalid={(navigatigAway && !transporterInfo.transporter_name) || (navigatigAway && ischeck)}
        isRequired
        className={classes['name-input']}
      />
      {ischeck ? <span style={{ color: 'red', fontSize: "10px" }}>* Transporter Name already in use</span> : null}

      {/* <Dropdown
        defaultValues={cloneDeep(Constants.CompanyTypes).filter(
          a => a.value === transporterInfo.company_type
        )}
        picklistOptions={cloneDeep(Constants.CompanyTypes)}
        onValueChange={selected =>
          replaceValueForKey(transporterInfo, 'company_type', selected.value)
        }
        placeholder="Select company type"
        className={classes['padding-0']}
      /> */}
      <Dropdown
        defaultValues={
          Array.isArray(Constants?.CompanyTypes)
            ? cloneDeep(Constants.CompanyTypes).filter(
              a => transporterInfo?.company_type && a.value === transporterInfo.company_type
            )
            : []
        }
        picklistOptions={
          Array.isArray(Constants?.CompanyTypes)
            ? cloneDeep(Constants.CompanyTypes)
            : []
        }
        onValueChange={selected =>
          replaceValueForKey(
            transporterInfo,
            'company_type',
            selected?.value ?? ''
          )
        }
        placeholder="Select company type"
        className={classes['padding-0']}
      />

      <span className={classes.asterisk}>*</span>
      <label className={`${classes['s-pad']}`}>Registered office address</label>
      <AutoComplete
        remoteUrl={Urls.Locations.Get}
        dataKey={'value'}
        valueKey={'location_name'}
        onSelect={s => {
          replaceValueForKey(transporterInfo, 'headquarter', s ? s.value : '');
        }}
        defaultValue={
          transporterInfo.headquarter
            ? {
              label: transporterInfo.headquarter,
              value: transporterInfo.headquarter
            }
            : undefined
        }
        placeholder="Headquarter"
        trimmed
        invalid={navigatigAway && !transporterInfo.headquarter}
        required
        hideAsterisk
        className={classes['padding-0']}
      />

      <InputWithLabel
        placeholder="Established year"
        label="Established Year"
        defaultValue={transporterInfo.established}
        onChange={value =>
          replaceValueForKey(transporterInfo, 'established', value)
        }
        className={classes['estb-input']}
      />
      <span className={classes.asterisk}>*</span>
      <label className={`${classes['s-pad']}`} style={{ paddingLeft: '2px' }}>Area of Operation</label>
      {/* <Dropdown
        defaultValues={cloneDeep(Constants.AreaOfOperation).filter(
          a => transporterInfo.zone && transporterInfo.zone.includes(a.value)
        )}
        picklistOptions={cloneDeep(Constants.AreaOfOperation)}
        onValueChange={selected =>
          replaceValueForKey(
            transporterInfo,
            'zone',
            selected && selected.length ? selected.map(s => s.value) : []
          )
        }
        isMultiselect
        placeholder="Select area of operation"
        isInvalid={navigatigAway && !transporterInfo.zone}
        isRequired={true}
        className={classes['padding-0']}
        required
        invalid={navigatigAway && !isValid(transporterInfo.zone)}
        ErrorMessage={'Please select atleast one Area of Operations '}
      /> */}
      {/* <Dropdown
        defaultValues={[
          ...cloneDeep(Constants.AreaOfOperation).filter(a => transporterInfo.zone && transporterInfo.zone.includes(a.value)),
          ...transporterInfo.zone.filter(zone => !Constants.AreaOfOperation.some(option => option.value === zone))
            .map(zone => ({ label: zone, value: zone }))
        ]}
        picklistOptions={[
          ...cloneDeep(Constants.AreaOfOperation),
          ...transporterInfo.zone.filter(zone => !Constants.AreaOfOperation.some(option => option.value === zone))
            .map(zone => ({ label: zone, value: zone }))
        ]}
        onValueChange={selected =>
          replaceValueForKey(
            transporterInfo,
            'zone',
            selected && selected.length ? selected.map(s => s.value) : []
          )
        }
        isMultiselect
        isNewOptionValid={true}
        placeholder="Select area of operation"
        isInvalid={navigatigAway && !transporterInfo.zone}
        isRequired={true}
        isSearchable={true}
        className={classes['padding-0']}
        required
        invalid={navigatigAway && !isValid(transporterInfo.zone)}
        ErrorMessage={'Please select at least one Area of Operations '}
      /> */}
      <Dropdown
        defaultValues={[
          ...(Array.isArray(Constants?.AreaOfOperation) ? cloneDeep(Constants.AreaOfOperation).filter(a =>
            Array.isArray(transporterInfo?.zone) && transporterInfo.zone.includes(a.value)
          ) : []),
          ...(Array.isArray(transporterInfo?.zone)
            ? transporterInfo.zone
              .filter(zone =>
                !Array.isArray(Constants?.AreaOfOperation) ||
                !Constants.AreaOfOperation.some(option => option.value === zone)
              )
              .map(zone => ({ label: zone, value: zone }))
            : [])
        ]}
        picklistOptions={[
          ...(Array.isArray(Constants?.AreaOfOperation) ? cloneDeep(Constants.AreaOfOperation) : []),
          ...(Array.isArray(transporterInfo?.zone)
            ? transporterInfo.zone
              .filter(zone =>
                !Array.isArray(Constants?.AreaOfOperation) ||
                !Constants.AreaOfOperation.some(option => option.value === zone)
              )
              .map(zone => ({ label: zone, value: zone }))
            : [])
        ]}
        onValueChange={selected =>
          replaceValueForKey(
            transporterInfo,
            'zone',
            selected && selected.length ? selected.map(s => s.value) : []
          )
        }
        isMultiselect
        isNewOptionValid={true}
        placeholder="Select area of operation"
        isInvalid={navigatigAway && (!Array.isArray(transporterInfo?.zone) || transporterInfo.zone.length === 0)}
        isRequired={true}
        isSearchable={true}
        className={classes['padding-0']}
        required
        invalid={navigatigAway && (!Array.isArray(transporterInfo?.zone) || transporterInfo.zone.length === 0)}
        ErrorMessage={'Please select at least one Area of Operations'}
      />
      <InputWithLabel
        placeholder="Experience:"
        label="Industry Experience"
        defaultValue={transporterInfo.experience_year}
        onChange={value =>
          replaceValueForKey(transporterInfo, 'experience_year', value)
        }
        className={classes['estb-input']}
      />
      {/* <label style={{ paddingLeft: '8px' }}>Incorporated under Companies Act</label>
      <Dropdown
        defaultValues={cloneDeep(Constants.CompanyAct).filter(
          a => a.value === transporterInfo.company_act
        )}
        picklistOptions={cloneDeep(Constants.CompanyAct)}
        onValueChange={selected =>
          replaceValueForKey(transporterInfo, 'company_act', selected.value)
        }
        placeholder="Select company Act"
        className={classes['padding-0']}
      /> */}
    </>
  );
};
const isValid = (value) => {
  if (value.length > 0)
    return true
  return false
}

export default GeneralInfo;
